/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  margin-top: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvb2ZmZXItYXJlYXMvc2VsZWN0LW9mZmVyLXByaW1hcnktYXJlYS9zZWxlY3Qtb2ZmZXItcHJpbWFyeS1hcmVhLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL29mZmVyLWFyZWFzL3NlbGVjdC1vZmZlci1wcmltYXJ5LWFyZWEvc2VsZWN0LW9mZmVyLXByaW1hcnktYXJlYS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/offer-areas/select-offer-primary-area/select-offer-primary-area.component.scss.shim.ngstyle.ts